import { render, staticRenderFns } from "./Todo.view.vue?vue&type=template&id=784aa5f5&"
import script from "./Todo.view.vue?vue&type=script&lang=js&"
export * from "./Todo.view.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports